import type { AIProvider } from './aiProvider';
import { GeminiProvider } from './geminiProvider';
import { ClaudeProvider } from './claudeProvider';

export * from './aiProvider';

const provider = import.meta.env.VITE_AI_PROVIDER || 'gemini';

let aiProvider: AIProvider;

if (provider === 'gemini') {
  const apiKey = import.meta.env.VITE_GEMINI_API_KEY;
  if (!apiKey) {
    throw new Error('VITE_GEMINI_API_KEY is required when using Gemini provider');
  }
  aiProvider = new GeminiProvider(apiKey);
} else if (provider === 'claude') {
  const apiKey = import.meta.env.VITE_ANTHROPIC_API_KEY;
  if (!apiKey) {
    throw new Error('VITE_ANTHROPIC_API_KEY is required when using Claude provider');
  }
  aiProvider = new ClaudeProvider(apiKey);
} else {
  throw new Error(`Unknown AI provider: ${provider}. Use "gemini" or "claude"`);
}

export { aiProvider };
